import { ArrowRight } from 'lucide-react';
import { useState } from 'react';
import Loader from './Loader';

const StatsCardGreenpill = ({
    label = 'IP earned till now',
    stats = 0,
    symbol = '',
    applyHover = false,
    className,
    loading,
    onClick,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleHover = (state) => {
        setIsHovered(state);
    };

    return (
        <div
            onMouseEnter={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
            onClick={onClick}
            className={`  bg-bsPrimary rounded-lg relative ${isHovered && applyHover ? 'shadow-stats-shadow cursor-pointer' : ''
                } border border-borderStats  ${className}  `}
        >
            <div className="flex flex-col px-3   md:px-5 py-3 ">
                <p className="text-sm md:text-base flex items-center gap-3 text-tSecondary font-medium">
                    <span>{label}</span>
                    <span>{applyHover && isHovered && <ArrowRight size={14} />}</span>
                </p>
                {loading ? (
                    <div className="flex flex-col px-3   md:px-5 py-3 md:py-4">
                        <Loader w="w-6" h="h-6" fillColor="fill-[#326F58]" />
                    </div>
                ) : (
                    <div className="flex items-center gap-1   mt-1 ">
                        {symbol && <span className="text-tsPrimary   ">{symbol}</span>}
                        <p className="text-tsPrimary  text-4xl ">{stats}</p>
                    </div>
                )}
            </div>
        </div>
    );
    return (
        <div
            onMouseEnter={() => handleHover(true)}
            onMouseLeave={() => handleHover(false)}
            onClick={onClick}
            className={` px-6 py-4 bg-bsPrimary rounded-lg relative ${isHovered && applyHover ? 'shadow-stats-shadow cursor-pointer' : ''
                }  ${className}  `}
            style={{
                position: 'relative',
                borderRadius: '0.3125rem',
                // background: 'linear-gradient(to top right, rgba(105, 159, 132, 1), rgba(80, 108, 102, 0))',
                background: 'linear-gradient(to top right, #BFD8CF, #BFD8CF)',
                padding: '1px', // Border thickness
                backgroundClip: 'border-box', // Ensures gradient stays on the border
            }}
        >
            <div
                className="bg-bsPrimary w-full h-full rounded-[inherit] px "
                style={{
                    borderRadius: '0.3125rem', // Matches parent border radius
                }}
            >
                <div className="flex flex-col px-3   md:px-5 py-3 ">
                    <p className="text-sm md:text-base flex items-center gap-3 text-textStatsLabel font-medium">
                        <span>{label}</span>
                        <span>{applyHover && isHovered && <ArrowRight size={14} />}</span>
                    </p>
                    {loading ? (
                        <div className="flex flex-col px-3   md:px-5 py-3 md:py-4">
                            <Loader w="w-6" h="h-6" fillColor="fill-[#326F58]" />
                        </div>
                    ) : (
                        <div className="flex items-center gap-1   mt-1 ">
                            {symbol && <span>{symbol}</span>}
                            <p className="text-textStats  text-4xl ">{stats}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StatsCardGreenpill;
